module.exports = __webpack_public_path__ + "img/datacover.ad48d95f.png";